<template>
  <div class="history-item_container">
    <div class="history-item_info spacey-4">
      <div class="history-item_info__title">{{ change.text }}</div>
      <div class="history-item_info__subtitle">
        {{ publisherInfo }}
      </div>
    </div>
  </div>
</template>

<script>
  import timeAgo from '@/utils/date/time-ago';

  export default {
    name: 'HistoryItem',
    props: {
      change: {
        type: Object,
        required: true,
      },
    },
    computed: {
      publisherInfo() {
        return `${this.change?.author_user?.name}, ${timeAgo(new Date(this.change?.created_at))}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .history-item {
    &_container {
      border: 1px solid $surface-border;
      box-sizing: border-box;
      border-radius: 8px;

      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px 12px 8px 12px;
    }
    &_info {
      margin-left: 8px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      &__title {
        color: $text-primary;
        size: 14px;
      }
      &__subtitle {
        color: $text-tertiary;
        size: 12px;
      }
    }
  }
</style>
